import { render } from "./VehicleDeviationCategoryInput.vue?vue&type=template&id=7b054278"
import script from "./VehicleDeviationCategoryInput.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationCategoryInput.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
